import React from 'react';
import PropTypes from 'prop-types';

import ProjectsContainer from '../../containers/ProjectsContainer'
import BreakLines from './BreakLines'
import List from './List'

const Block = ({ children, content = {}, activeKeywords = [], onMouseOver, onMouseOut, ...props }) => {
  let title, body;

  switch (content.type) {
    case "primary":
      title = <h3>{content.title}</h3>;
      break;

    case "secondary":
      title = <em>{content.title}</em>;
      break;

    default:
  }

  switch (content.format) {
    case "break-line":
      body = <BreakLines items={content.items} />
      break;

    case "list":
      body = <List items={content.items} activeKeywords={activeKeywords} />
      break;

    case "project-list":
      body = <ProjectsContainer items={content.items} onMouseOver={onMouseOver} onMouseOut={onMouseOut} />
      break;

    default:
  }

  return (
    <div className="block">
      {title}
      {body}
    </div>
  );
};

Block.propTypes = {
  content: PropTypes.object.isRequired,
  activeKeywords: PropTypes.array,
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func
};

export default Block;



// WEBPACK FOOTER //
// ./src/components/resume/Block.js